export default class RentalPackageReplyForm {

    /**
     * @param element
     * @param gtm
     * @param w
     */
    constructor(element, gtm, w) {
        this.window = w || window;
        this.gtm = gtm;
        this.$element = $(element);
        this.$text = this.$element.data('rental-package-reply-form');
        this.$target = this.$element.data('rental-package-reply-form-target');
        this.$trackingLabel = this.$element.data('rental-package-reply-form-label');
        this.setup();
    }

    setup() {
        this.$element.off('click.rental')
            .on('click.rental', this.setRentalPackageReplyFormText.bind(this))
            .on('click.rental', this.trackEvent.bind(this));
    }

    setRentalPackageReplyFormText() {
        $('#' + this.$target).val(this.$text);
    }

    trackEvent() {
        this.gtm.trackEvent('R2SRentalBegin', this.$trackingLabel);
    }

}
